// @flow
import { connect } from 'react-redux';

import RencontreMedias from 'components/rencontre/RencontreMedias';

import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/rencontre/RencontreMedias';

const mapStateToProps = (state: StateType): StateProps => ({
  album: state.albumState.album,
  status: state.albumState.albumStatus,
  rencontre: state.rencontreState.rencontre
});

export default connect(mapStateToProps)(RencontreMedias);
